// Composables
import {createRouter, createWebHistory} from 'vue-router'
import TranslationService from "@/services/translation";
import i18n from "@/plugins/i18n";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'default',
      redirect: i18n.global.t('router.home')
    },
    {
      path: `/:locale(en)`,
      alias: `/:locale(es)`,
      component: () => import('@/layouts/default/Default.vue') ,
      beforeEnter: TranslationService.routeMiddleware,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/HomeView.vue'),
        },
        {
          path: '/:locale(en)/terms-and-conditions',
          alias: '/:locale(es)/terminos-y-condiciones',
          name: 'terms-and-conditions',
          component: () => import('@/views/TermAndConditionsView.vue'),
        },
      ],
    },
  ],
})

export default router
